import { useEffect, useRef, useState } from 'react';
import { useLoadingState } from '../../hooks/useLoader';
import { createBounty, getBounty } from '../../apis/bounties/bounties';
import Overlay from '../../ui/Overlay';
import ModalBox from '../../ui/ModalBox';
import { sanitizeBountyData } from '../../helpers/sanitizeBountyDetails';
import { toast } from 'sonner';
import { toggleOnboardBounty } from '../../apis/events/getEvents';

function ToggleOnboardBountyModal({ close, bountyName, bountyId, handleConfirmAction, eventId, isOnboardingBounty }) {
    const modalRef = useRef(null); // Reference for the modal content
    const { loading, startLoading, stopLoading } = useLoadingState();
    const [bountyPayload, setBountyPayload] = useState({});

    useEffect(() => {
        // Fetch the bounty data asynchronously
        const fetchData = async () => {
            try {
                const data = await getBounty(bountyId);
                setBountyPayload(data);
            } catch (error) {
                console.error('Error fetching bounty:', error);
            }
        };
        fetchData();

        // Handle click outside the modal
        function handleClickOutside(e) {
            // Check if the click was outside the modal content
            if (modalRef.current && !modalRef.current.contains(e.target)) {
                close(); // Close the modal if clicked outside
            }
        }

        // Add event listener in the capture phase to ensure proper handling
        document.addEventListener('mousedown', handleClickOutside, true);

        return () => {
            // Clean up the event listener on unmount
            document.removeEventListener('mousedown', handleClickOutside, true);
        };
    }, [close, bountyId]);

    return (
        <Overlay>
            <div
                ref={modalRef} // Attach ref to modal content
                className="absolute rounded-lg left-[50%]     bg-grayBgNormal translate-x-[-50%] translate-y-[-50%] top-[50%]"
                onClick={(e) => e.stopPropagation()} // Stop propagation to avoid closing the modal when clicked inside
            >
                <ModalBox
                    close={close}
                    onSubmit={async () => {
                        try {
                            startLoading();
                            const response = await toggleOnboardBounty(bountyId, eventId, isOnboardingBounty);

                            if (response?.onboardingBounty)
                                toast.success('Bounty successfully converted to register bounty. ');
                            else {
                                toast.success('Bounty successfully converted to normal bounty. ');
                            }
                            handleConfirmAction(response);
                        } catch (error) {
                            console.log(error);
                        } finally {
                            close(); // Close modal after duplication
                            stopLoading();
                        }
                    }}
                    primaryBtnText={'Submit'}
                    loading={loading}
                    secondaryBtnText={'Cancel'}
                >
                    <>
                        Are you sure you want to <span className="font-bold">convert bounty '{bountyName}' </span> to
                        {isOnboardingBounty ? ' normal' : ' register'} bounty ?
                    </>
                </ModalBox>
            </div>
        </Overlay>
    );
}

export default ToggleOnboardBountyModal;
